import { Link, Box } from '@material-ui/core';
import { useLocalization } from 'Hooks';
import { FC } from 'react';
import classNames from 'classnames';
import { Avatar } from 'Components';
import { useSelector } from 'react-redux';
import { userStore } from 'Stores/User/slices';
import { get } from 'lodash';
import { useHistory } from 'react-router-dom';
import { routePath } from 'Navigator/routes';
import { formatFullName } from 'Utils';

import './ProfileAvatar.scss';

type ProfileAvatarProps = {
  isHomePage?: boolean;
};

const ProfileAvatar: FC<ProfileAvatarProps> = ({ isHomePage }) => {
  const history = useHistory();

  const { web_hesabım_profil_homepage } = useLocalization();

  const userData = useSelector(userStore);
  const isResetPassword = userData?.resetPassword;

  const name = get(userData, 'name');
  const middleName = get(userData, 'middleName');
  const surname = get(userData, 'surname');

  const handleNavigate = () => {
    if (!isResetPassword) history.push(routePath.myAccount);
  };

  return (
    <div
      id="profile"
      role="button"
      tabIndex={isResetPassword ? -1 : 0}
      aria-label={`${formatFullName(name, middleName, surname)}, ${web_hesabım_profil_homepage ?? 'Hesabım'}`.trim()}
      aria-disabled={isResetPassword}
      onClick={()=>(isResetPassword ? undefined: history.push(routePath.myAccount))}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleNavigate();
        }
      }}
      itemID="navigateAccountBtnTest"
    >
      <Box
        display="flex"
        className={classNames({
          'profileAvatar--blue': isHomePage,
          'profileAvatar--white': !isHomePage,
        })}
      >
        <Avatar />
        <Box className="profileAvatar__userBlock">
          <Box display="flex">
            {/* Her ad bileşeni ayrı kutuda: SCSS'teki `first-letter` kuralı sayesinde
                ikinci adın da baş harfi büyür, tek kutuda birleştirilseydi küçük kalırdı. */}
            <Box className="user--name" fontWeight="bold">
              {name?.toLocaleLowerCase('tr-TR')}
            </Box>
            {!!middleName && (
              <Box className="user--name" fontWeight="bold">
                {middleName.toLocaleLowerCase('tr-TR')}
              </Box>
            )}
            <Box className="user--name" fontWeight="bold">
              {surname?.toLocaleLowerCase('tr-TR')}
            </Box>
          </Box>
          <Box className="profileAvatar__myAccountLink" fontWeight="bold">
            <Link underline="none">{web_hesabım_profil_homepage}</Link>
          </Box>
        </Box>
      </Box>
    </div>
  );
};
export default ProfileAvatar;
